import Cookies from "js-cookie";
const handleLogout = () => {
  Cookies.remove("accessToken");
  window.location.reload();
};

export default handleLogout;
